"use client";

import { Typography } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { memo } from "react";
import { industriesHeroData } from "./constants";
import { IndustriesHeroProps } from "./types";

const IndustriesHero = ({ className, ...rest }: IndustriesHeroProps) => {
  const {
    title,
    description,
    primaryButton,
    secondaryButton,
    imageUrl,
    imageDimensions,
  } = industriesHeroData;
  return (
    <section
      className={cn(
        "overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero",
        className
      )}
      {...rest}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 pb-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[minmax(0,259fr)_minmax(0,301fr)] lg:gap-0 lg:py-20">
          <div className="flex flex-col lg:justify-center gap-8 lg:max-w-[518]">
            <div className="grid grid-cols-1 place-content-start gap-4 md:gap-8">
              <Typography variant="headingMain" className="w-full">
                <h1>{title}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>{description}</p>
              </Typography>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap lg:gap-2.5">
              {!!primaryButton && (
                <Button
                  asChild
                  variant="primary"
                  className="sm:w-[247px] h-[48px]"
                >
                  <Link href={primaryButton.href} className="!text-base w-full">
                    {primaryButton.label}
                  </Link>
                </Button>
              )}
              {!!secondaryButton && (
                <Button
                  asChild
                  variant="primary-outline"
                  className="h-[48px] sm:w-[141px]"
                >
                  <Link
                    href={secondaryButton?.href}
                    className="!text-base w-full"
                  >
                    {secondaryButton?.label}
                  </Link>
                </Button>
              )}
            </div>
          </div>
          {imageUrl && (
            <div className="flex items-start">
              <Image
                alt="Languex Illustration"
                src={imageUrl}
                width={imageDimensions?.width}
                height={imageDimensions?.height}
                className="flex-auto min-w-0"
                priority
                quality={80}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 60vw, 640px"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(IndustriesHero);
